import { useAppDispatch, useAppSelector } from "store/hooks"
import {
  showAccountSettingsModal,
  showDamageDeviceModalForVendor,
  showDeviceHistoryLogModal,
  showEditOrderModal,
  showEditOrderModalOld,
  showMissingModalForVendor,
  showNewOrderModal,
  showNewOrderModalOld,
  showPerformanceTestConfirmModal,
  showPerformanceTestFailModal,
  showPerformanceTestReportModal,
  showReturnToWarehouseModal,
  showSeeMessageModal,
  showTermsOfUseModal,
  showTransferDeviceModal,
  showUndamageDeviceModalForVendor,
  showWarrantyModal,
} from "store/modalSlise"

import { AccountSettingsModal } from "modals/AccountSettingsModal"
import { DamageDeviceModalForVendor } from "modals/DamageDeviceModalForVendor"
import { DeviceHistoryLogModal } from "modals/DeviceHistoryLogModal"
import { EditOrderModal } from "modals/EditOrderModal"
import { MissingModalVendor } from "modals/MissingModalVendor"
import { NewOrderModal } from "modals/NewOrderModal"
import { PerformanceTestConfirmModal } from "modals/PerformanceTestConfirmModal"
import { PerformanceTestFailModal } from "modals/PerformanceTestFailModal"
import { PerformanceTestReportModal } from "modals/PerformanceTestReportModal"
import { ReturnToWarehouseModal } from "modals/ReturnToWarehouseModal"
import { SeeMessageModal } from "modals/SeeMessageModal"
import { ShippingWarningModal } from "modals/ShippingWarningModal"
import { TermOfUseModal } from "modals/TermOfUseModal"
import { TransferDeviceModal } from "modals/TransferDeviceModal"
import { UndamageDeviceModalForVendor } from "modals/UndamageDeviceModalForVendor"
import { WarrantyModal } from "modals/WarrantyModal"

import { EditOrderModalOld } from "./EditOrderModalOld"
import { NewOrderModalOld } from "./NewOrderModalOld"

export const Modals = () => {
  const dispatch = useAppDispatch()
  const isNewOrderModalVisible = useAppSelector(state => state.modals.isNewOrderModalVisible)
  const isEditOrderModalVisible = useAppSelector(state => state.modals.isEditOrderModalVisible)
  const isMissingModalForVendorVisible = useAppSelector(state => state.modals.isMissingModalForVendorVisible)
  const isTermsOfUseModalVisible = useAppSelector(state => state.modals.isTermsOfUseModalVisible)
  const isShippingWarningModalVisible = useAppSelector(state => state.modals.isShippingWarningModalVisible)
  const isDamageDeviceModalForVendorVisible = useAppSelector(state => state.modals.isDamageDeviceModalForVendorVisible)
  const isUndamageDeviceModalForVendorVisible = useAppSelector(
    state => state.modals.isUndamageDeviceModalForVendorVisible,
  )
  const isTransferDeviceModalVisible = useAppSelector(state => state.modals.isTransferDeviceModalVisible)
  const isReturnToWarehouseModalVisible = useAppSelector(state => state.modals.isReturnToWarehouseModalVisible)
  const isWarrantyModalVisible = useAppSelector(state => state.modals.isWarrantyModalVisible)
  const isDeviceHistoryLogModalVisible = useAppSelector(state => state.modals.isDeviceHistoryLogModalVisible)
  const isAccountSettingsModalVisible = useAppSelector(state => state.modals.isAccountSettingsModalVisible)

  const isPerformanceTestConfirmModalVisible = useAppSelector(
    state => state.modals.isPerformanceTestConfirmModalVisible,
  )
  const isPerformanceTestFailModalVisible = useAppSelector(state => state.modals.isPerformanceTestFailModalVisible)
  const isPerformanceTestReportModalVisible = useAppSelector(state => state.modals.isPerformanceTestReportModalVisible)
  const isSeeMessageModalVisible = useAppSelector(state => state.modals.isSeeMessageModalVisible)
  const isNewOrderModalVisibleOld = useAppSelector(state => state.modals.isNewOrderModalVisibleOld)
  const isEditOrderModalVisibleOld = useAppSelector(state => state.modals.isEditOrderModalVisibleOld)

  return (
    <>
      {isNewOrderModalVisible && <NewOrderModal onCancel={() => dispatch(showNewOrderModal(false))} />}
      {isEditOrderModalVisible && <EditOrderModal onCancel={() => dispatch(showEditOrderModal(false))} />}
      {isNewOrderModalVisibleOld && <NewOrderModalOld onCancel={() => dispatch(showNewOrderModalOld(false))} />}
      {isEditOrderModalVisibleOld && <EditOrderModalOld onCancel={() => dispatch(showEditOrderModalOld(false))} />}
      {isMissingModalForVendorVisible && (
        <MissingModalVendor onCancel={() => dispatch(showMissingModalForVendor(false))} />
      )}
      {isTermsOfUseModalVisible && <TermOfUseModal onCancel={() => dispatch(showTermsOfUseModal(false))} />}
      {isDamageDeviceModalForVendorVisible && (
        <DamageDeviceModalForVendor onCancel={() => dispatch(showDamageDeviceModalForVendor(false))} />
      )}
      {isUndamageDeviceModalForVendorVisible && (
        <UndamageDeviceModalForVendor onCancel={() => dispatch(showUndamageDeviceModalForVendor(false))} />
      )}
      {isShippingWarningModalVisible && <ShippingWarningModal />}
      {isTransferDeviceModalVisible && (
        <TransferDeviceModal onCancel={() => dispatch(showTransferDeviceModal(false))} />
      )}
      {isReturnToWarehouseModalVisible && (
        <ReturnToWarehouseModal onCancel={() => dispatch(showReturnToWarehouseModal(false))} />
      )}
      {isWarrantyModalVisible && <WarrantyModal onCancel={() => dispatch(showWarrantyModal(false))} />}
      {isDeviceHistoryLogModalVisible && (
        <DeviceHistoryLogModal onCancel={() => dispatch(showDeviceHistoryLogModal(false))} />
      )}
      {isAccountSettingsModalVisible && (
        <AccountSettingsModal onCancel={() => dispatch(showAccountSettingsModal(false))} />
      )}
      {isPerformanceTestConfirmModalVisible && (
        <PerformanceTestConfirmModal onCancel={() => dispatch(showPerformanceTestConfirmModal(false))} />
      )}
      {isPerformanceTestFailModalVisible && (
        <PerformanceTestFailModal onCancel={() => dispatch(showPerformanceTestFailModal(false))} />
      )}
      {isPerformanceTestReportModalVisible && (
        <PerformanceTestReportModal onCancel={() => dispatch(showPerformanceTestReportModal(false))} />
      )}
      {isSeeMessageModalVisible && <SeeMessageModal onCancel={() => dispatch(showSeeMessageModal(false))} />}
    </>
  )
}
